import React, { useEffect, useState, useRef } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//observer
import { useInView } from 'react-intersection-observer';
//styles
import styles from 'src/asset/scss/style/notify.module.scss';
//Store 
import useComnStore from 'src/webapp/stores/comn.store';
import usePartnerStore from 'src/webapp/stores/partner.store';
//comp-wrapper
import Section from 'src/webapp/views/wrapper/Section';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import Menu from 'src/webapp/views/component/Menu';//메뉴
import TitleBar from 'src/webapp/views/component/title/TitleBar';//상단-타이틀
import Notify from './Notify';//공통엘리먼트
import EmptyData from 'src/webapp/views/component/EmptyData';//데이터없음
import Spinner from 'src/webapp/views/component/loading/Spinner';//inview로딩

export default function NoticeList() {
    const { axiosPostHandler } = useAxiosHook();//axios
    const { socket } = useComnStore();
    const { isState, partner } = usePartnerStore();

    /* =============== 알람리스트호출 =============== */
    const isLock = useRef(false);
    const pageRef = useRef(0);
    const [ notifyList, setNotifyList ] = useState([]);
    const notifyListAPI = async(type) => {//type-0.첫로딩 or Socket, 1.스크롤
        if(isLock.current) { return; }
        
        isLock.current = true;
        const DATA = { PARTNER_CD: partner.COMN_CD, SEQ_NO:type == 0 ? 0 : pageRef.current };
        const result = await axiosPostHandler(`partnerNotifyListForPartner.do`, DATA);
        setTimeout(function() { isLock.current = false; }, 300);
        if(!result || result.message !== "SUCCESS") { pageRef.current = null; return; }
        if(result.message === "SUCCESS") {
            setNotifyList(notifyList.concat(result.data));
            pageRef.current = result.data.length >= 20 ? result.data[result.data.length - 1].SEQ_NO : null;
        }
    };
    useEffect(() => {
        if(!isState) { return; }
        
        notifyListAPI(0);
    }, [isState, socket]);//소켓으로 새요청 및 예약변경요청이 있을경우 호출
    /* =============== 알람리스트호출 =============== */
    /* =============== 알람리스트 무한로딩호출 =============== */
    const [ inViewRef, inView] = useInView({ threshold: .5 });
    useEffect(() => {
        if(!inView && (notifyList.length <= 0 || pageRef.current === null)) { return; }
        
        notifyListAPI(1);
    }, [inView]);
    /* =============== 알람리스트 무한로딩호출 =============== */
    /* =============== 자세히보기 =============== */
    const [ toggle,setToggle ] = useState(null);
    /* =============== 자세히보기 =============== */

    return (
        <Section className={"section sectionContainer"}>
            <Menu />
            <Element tag={`div`} className={`container`}>
                <FixedPanel>
                    <TitleBar title={`알림`} />
                </FixedPanel>
                <FlickPanel>
                    {notifyList.length > 0 ?
                        <Element tag={`ul`} className={styles.notifyContainer}>
                            {notifyList.map((item, idx) => 
                                <Element tag={`li`} key={idx}><Notify data={item} toggle={toggle} setToggle={setToggle} /></Element>
                            )}
                        </Element>
                    : <Element tag={`div`} className={styles.emptyData}><EmptyData content={`알람은`} /></Element> }
                    {pageRef.current !== null && notifyList.length > 0 ? <Element tag={`div`} propRef={inViewRef}><Spinner inView={true} /></Element> : null}
                </FlickPanel>
            </Element>
        </Section>
    );
}